import { Link, useParams } from 'react-router-dom';
import { Card, PageState } from '../../components/ui';
import { useAutomation, useAutomationExecutions } from '../../api/automations';

export function AutomationExecutionsPage() {
  const { id } = useParams<{ id: string }>();
  const automation = useAutomation(id);
  const executions = useAutomationExecutions(id);

  return (
    <div style={{ display: 'grid', gap: 'var(--space-4)' }}>
      <h1 style={{ margin: 0, fontSize: 'var(--font-size-xl)' }}>
        Execution history{automation.data ? ` — ${automation.data.name}` : ''}
      </h1>

      {executions.isPending ? (
        <PageState kind="loading" message="Loading executions…" />
      ) : executions.isError ? (
        <PageState
          kind="error"
          message={executions.error.message}
          onRetry={() => void executions.refetch()}
        />
      ) : executions.data.items.length === 0 ? (
        <PageState kind="empty" title="No executions yet" message="Nothing has run yet." />
      ) : (
        <div style={{ display: 'grid', gap: 'var(--space-3)' }}>
          {executions.data.items.map((ex) => (
            <Card key={ex.id}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
                <span className="ne-badge">{ex.status}</span>
                <strong>{ex.triggerType}</strong>
                <span style={{ flex: 1 }} />
                <span style={{ color: 'var(--color-text-muted)', fontSize: 'var(--font-size-sm)' }}>
                  attempts: {ex.attempts}
                </span>
              </div>
              <div
                style={{
                  display: 'grid',
                  gap: 'var(--space-1)',
                  marginTop: 'var(--space-2)',
                  fontSize: 'var(--font-size-sm)',
                  color: 'var(--color-text-muted)',
                }}
              >
                <span>Created: {ex.createdAt}</span>
                {ex.startedAt ? <span>Started: {ex.startedAt}</span> : null}
                {ex.completedAt ? <span>Completed: {ex.completedAt}</span> : null}
              </div>
              {ex.status === 'FAILED' && ex.errorMessage ? (
                <p style={{ color: 'var(--color-danger)', margin: 'var(--space-2) 0 0' }}>
                  {ex.errorCode ? `${ex.errorCode}: ` : ''}
                  {ex.errorMessage}
                </p>
              ) : null}
              {ex.metadata && Object.keys(ex.metadata).length > 0 ? (
                <pre
                  style={{
                    marginTop: 'var(--space-2)',
                    padding: 'var(--space-2)',
                    background: 'var(--color-surface-muted, #f4f4f4)',
                    borderRadius: 'var(--radius-sm, 4px)',
                    overflowX: 'auto',
                    fontSize: 'var(--font-size-sm)',
                  }}
                >
                  {JSON.stringify(ex.metadata, null, 2)}
                </pre>
              ) : null}
            </Card>
          ))}
        </div>
      )}

      <p style={{ margin: 0, fontSize: 'var(--font-size-sm)' }}>
        <Link to="/automations">← All automations</Link>
      </p>
    </div>
  );
}
